import React from "react";

export const BetaBadge: React.FC = () => {
  return (
    <div className="bg-[#08262A] w-[60px] h-[20px] flex items-center justify-center rounded-[12px] ">
      <span className="text-[10px] text-[#00E0FF] font-medium">BETA</span>
    </div>
  );
};
